var map = {
	"./lang-en": 52,
	"./lang-en.js": 52,
	"./lang-ko": 53,
	"./lang-ko.js": 53,
	"./lang-th": 54,
	"./lang-th.js": 54,
	"./lang-zh": 55,
	"./lang-zh.js": 55
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/lang\-.*$
// module id = 19
// module chunks = 0